import { Button, Input, Modal, Space } from "antd";
import { OperationWrapper, ToolBarWrapper, TableWrapper, UserDeviceMappingList, UserDeviceMappingManagementWrapper, SearchInputWrapper } from "./UserDeviceMappingManagerment.styled";
import { useEffect, useState } from "react";
import Table, { ColumnType } from "antd/es/table";
import { CheckCircleFilled, CloseCircleFilled, SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import StringUtils from "../../../../util/StringUtils";
import PermissionApi from "../../../../api/PermissionApi";
import DeviceApi from "../../../../api/DeviceApi";
import DeviceSelection from "../../../../components/ui-components/device-selection/DeviceSelection";


const UserDeviceMappingManagement: React.FC<UserDeviceMappingManagementProps> = (props)=> {

    // api
    let permissionApi = new PermissionApi();
    let deviceApi = new DeviceApi();

    // state
    let [deviceViews, setDeviceViews] = useState([]);
    let [keyword, setKeyword] = useState("");
    let [openDeviceSelection, setOpenDeviceSelection] = useState(false);
    let [loading, setLoading] = useState(true);
    
    // fitlered device views
    let filterDeviceViews = StringUtils.isEmpty(keyword) ? deviceViews : 
        deviceViews.filter(e => e.device.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1);

    // events
    let onSearch = (value)=> {
        setKeyword(value);
    };

    let onAddDeviceBtnClick = ()=> {
        setOpenDeviceSelection(true);
    };

    let onOk = async ()=> {
        let setUserDevicesResponse = (await permissionApi.setUserDevices({
            userId: props.userId,
            deviceIds: deviceViews.map(e => e.device.id)
        })).data.data;
        props.onOk();
    };

    let onCancel = ()=> {
        props.onCancel();
    };

    let onDeleteDevice = (deviceView)=> {
        let newDevices = deviceViews.filter(e => e.device.id != deviceView.device.id);
        setDeviceViews(newDevices);
    };

    // column definition
    let columns: ColumnType<any>[] = [
        {
            title: '状态',
            dataIndex: 'node.status',
            key: "node.status",
            align: 'center',
            render: (text, record, index)=> {
                return record.node.status == 'ONLINE' 
                    ? <CheckCircleFilled style={{color: 'green'}} />
                    : <CloseCircleFilled style={{color: 'grey'}} />
            }
        },
        {
            title: '设备名称',
            dataIndex: 'device.name',
            key: 'device.name',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{record.device.name}</span>
            }
        },
        {
            title: '序列号',
            dataIndex: 'node.sn',
            key: 'node.sn',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{record.node.sn}</span>
            }
        },
        {
            title: '设备模板',
            dataIndex: 'template.name',
            key: 'template.name',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{record.deviceTemplate?.name}</span>
            }
        },
        {
            title: '最后在线时间',
            dataIndex: 'node.lastSeenTime',
            key: 'node.lastSeenTime',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{ moment(parseInt(record.node.lastSeenTime)).format("YYYY-MM-DD HH:mm:ss") }</span>
            }
        },
        {
            title: '备注',
            dataIndex: 'device.remarks',
            key: 'device.remarks',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{StringUtils.emptyToSlash(record.device.remarks)}</span>
            }
        },
        {
            title: '操作',
            key: 'action',
            align: 'center',
            render: (text, record, index)=> {
                return <Space size="middle">
                    <a onClick={()=> onDeleteDevice(record)}>删除</a>
                </Space>
            }
        }
    ];

    useEffect(()=> {
        let loadDeviceViews = async ()=> {
            let deviceIds = (await permissionApi.getUserDevices(props.userId)).data.data;
            let deviceViews = (await deviceApi.batchGetDeviceViews(deviceIds)).data.data;
            setDeviceViews(deviceViews);
            setLoading(false);
        };
        loadDeviceViews();
    }, []);

    // render
    return <UserDeviceMappingManagementWrapper>
        <UserDeviceMappingList>
            <ToolBarWrapper>
                <Button type="primary" onClick={onAddDeviceBtnClick}>添加设备</Button>
                <SearchInputWrapper>
                    <Input size="large" onChange={(e)=> onSearch(e.target.value)} suffix={<SearchOutlined />} />
                </SearchInputWrapper>
            </ToolBarWrapper>
            <TableWrapper>
                <Table
                    rowKey={(record)=> record.device.id}
                    columns={columns} 
                    dataSource={deviceViews}
                    loading={loading}
                />
            </TableWrapper>
            
            <Modal open={openDeviceSelection} 
                onClose={()=> setOpenDeviceSelection(false)} 
                footer={null} 
                closable={false}
                destroyOnClose={true}
                width={1200}
                >
                <DeviceSelection
                    multiSelection={true}
                    onOk={(selectedDeviceViews)=> {
                        setOpenDeviceSelection(false);
                        let addSelectedDeviceViews = selectedDeviceViews.filter(e => !deviceViews.find(f => f.device.id == e.device.id));
                        setDeviceViews(deviceViews.concat(addSelectedDeviceViews));
                    }}
                    onCancel={()=> setOpenDeviceSelection(false)}
                />
            </Modal>

        </UserDeviceMappingList>

        <OperationWrapper>
            <Space size="middle">
                <Button type="primary" onClick={onOk}>确定</Button>
                <Button type="primary" danger onClick={onCancel}>取消</Button>
            </Space>
        </OperationWrapper>
    </UserDeviceMappingManagementWrapper>
};

interface UserDeviceMappingManagementProps {
    userId: string;
    onOk: ()=> void;
    onCancel: ()=> void;
}

export default UserDeviceMappingManagement;

